module.exports = __webpack_public_path__ + "img/ministry_of_netherlands.2f3a4d11.png";